var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafetyInfractionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5659 23.9613L19.5246 1.66762C18.9283 0.616247 17.8107 0 16.5065 0C15.2023 0 14.1218 0.616215 13.4885 1.66762L0.447175 23.9613C-0.149058 25.0124 -0.149058 26.2813 0.447175 27.3324C1.04341 28.3835 2.16131 29 3.42811 29H29.4734C30.7402 29 31.8581 28.3838 32.4543 27.3324C33.1621 26.2813 33.1621 25.0124 32.5659 23.9613ZM18.4068 23.7074H14.9416V20.7712H18.4068V23.7074ZM18.4068 19.0674H14.9416V10.6575H18.4068V19.0674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyInfractionsIcon);
export default __webpack_public_path__ + "static/media/safetyInfractionsIcon.df605d601655f7bfa3244ee9eaa6fc6e.svg";
export { ForwardRef as ReactComponent };